import React from 'react';
import Icon from '../../../components/AppIcon';

const TicketTrendChart = ({ data }) => {
  const maxValue = Math.max(...(data?.map(d => Math.max(d?.created || 0, d?.resolved || 0)) || [1]));

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Icon name="TrendingUp" className="w-5 h-5 text-blue-600" />
          Ticket Trends
        </h3>
        <div className="flex items-center gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-blue-500 rounded" />
            <span className="text-gray-600">Created</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-green-500 rounded" />
            <span className="text-gray-600">Resolved</span>
          </div>
        </div>
      </div>

      {data?.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <Icon name="TrendingUp" className="w-12 h-12 text-gray-300 mx-auto mb-2" />
          <p>No trend data available</p>
        </div>
      ) : (
        <div className="space-y-3">
          {data?.slice(-14)?.map((item, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-gray-600">
                  {new Date(item?.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                </span>
                <div className="flex items-center gap-3 text-xs text-gray-600">
                  <span>{item?.created} created</span>
                  <span>{item?.resolved} resolved</span>
                </div>
              </div>
              <div className="flex gap-1 h-8">
                <div
                  className="bg-blue-500 rounded transition-all"
                  style={{ width: `${(item?.created / maxValue) * 100}%` }}
                  title={`${item?.created} created`}
                />
                <div
                  className="bg-green-500 rounded transition-all"
                  style={{ width: `${(item?.resolved / maxValue) * 100}%` }}
                  title={`${item?.resolved} resolved`}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TicketTrendChart;
